<template>
<div>
  <columns>
    <column>
      <p>{{ app.domain }}, has been successfully created. Please complete the steps below to finish setting up your app.</p>
    </column>
  </columns>
  <p>
    1. Installation
  </p>
  <div class="code">
    <p>
      <span class="has-text-white">$</span> composer require snitchy/snitch-laravel-sdk
    </p>
  </div>
  <p>
    2. Add the credentials below to your .env file. <span class="tag is-danger">Secret is only shown once.</span>
  </p>
  <env-keys :keys="keys"/>
  <p>
    4. Run the installation assistant.
  </p>
  <div class="code">
    <p>
      php artisan snitch:install
    </p>
  </div>  

  <columns>
    <column class="has-text-centered">
      <router-link 
        class="button is-rounded is-outlined is-info"
        :to="{
          name: 'app-manager',
          params: {
            app: app.id
          }
        }">
        <span>Continue to app manager</span>
        <icon icon="arrow-right"/>
      </router-link>
    </column>
  </columns>
</div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {

  created() {
    this.$bus.$emit('set-title', 'App created successfully')
  },
  
  computed: {
    ...mapGetters('app', [
      'keys',
      'app'
    ])
  }

}
</script>